import React, { useState, useContext, useRef, memo, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Login, Recaptchahandler } from '@/api/endpoints';
import ReCAPTCHA from 'react-google-recaptcha';
import './style.css';
import AuthWrapper from './components/authWrapper';
import ActionBtn from '../../components/ActionBtn';
import { Block } from '../../components/crRender';
import RememberMe from './components/rememberMe';
import useForm from '../../hooks/useForm';
import InputField from '../../components/formFields/InputField';
import { GetLocStorage, SetLocStorage } from '../../utils';
import { PrivilegeContext } from '../../context/PrivilegesContext';
import { DomainContext } from '../../context/DomainContext';
import { Icon } from '@iconify/react/dist/iconify.js';

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITEKEY
const isRecaptchaEnabled = Boolean(recaptchaSiteKey)

const SignIn = () => {

    const [isHuman, setIsHuman] = useState(!isRecaptchaEnabled);

    const { setIsLoggedIn } = useContext(PrivilegeContext)
    const { setLoading } = useContext(DomainContext)

    const captchaRef = useRef(null);
    const email = useMemo(() => GetLocStorage("email"), [])
    const password = useMemo(() => GetLocStorage("password"), [])

    const { t, i18n } = useTranslation()
    const navigate = useNavigate()

    const { onSubmit, formHandler, formDataResult } = useForm()


    const handleSubmit = () => {
        setLoading(l => l + 1)
        Login(formDataResult, i18n.language).then(res => {
            SetLocStorage('ut', res.data.accessToken)
            SetLocStorage('rt', res.data.refreshToken)
            setIsLoggedIn(true)
            navigate('/panel')
        }).catch(() => {

        }).finally(() => setLoading(l => l - 1))
    }

    const recaptchahandler = () => {
        const token = captchaRef.current?.getValue()
        if (!token) {
            setIsHuman(false)
            return
        }
        const RecaptchaData = { token }

        Recaptchahandler(RecaptchaData).then(res => {
            setIsHuman(Boolean(res.data))
        }).catch(() => {
            setIsHuman(false)
        })
    }

    const handleChangeLanguage = () => {
        var newLanguage = i18n.language === "ar" ? "en" : "ar";
        i18n.changeLanguage(newLanguage);
        SetLocStorage('i18nextLng', newLanguage)
    }



    return (
        <AuthWrapper >
            <InputField lang='any' isLoading={false} className={"col-md-12"} type={"email"} name={"email"} formHandler={formHandler} defaultValue={email} />
            <InputField lang='any' isLoading={false} className={"col-md-12"} type={"password"} name={"password"} formHandler={formHandler} defaultValue={password} />

            <div className='forget-password-container'>
                <RememberMe dataObject={formDataResult} />
                <Link to='/auth/forget-password' className='forgetP-password-link'>{t("forgetPassword")}</Link>
            </div>

            {/*
          <Block className={"recaptcha-container"} isRender={isRecaptchaEnabled}>
            <ReCAPTCHA className='recaptcha' sitekey={recaptchaSiteKey} ref={captchaRef} onChange={recaptchahandler} />
            </Block>
              */}

            <ActionBtn
                //isDisabled={!isHuman}
                className={"login-btn"} onApply={() => onSubmit(handleSubmit)} title={"login"} />
        </AuthWrapper>

    );
}

export default memo(SignIn);

